import React, { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FindingYourOrangeCountyHome() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => {
    setIsMounted(true);
  }, []);
  const businessName = "Find a home with chris";
  const location = "Orange County, New York";
  const description = "Helping families buy homes.\xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 Millennial dad of 2 | Hudson Valley Realtor\xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0\xA0 Here to make home buying simple.\xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0\xA0";
  return <section id="finding-your-orange-county-home" className="relative w-full overflow-hidden bg-sidebar-accent" aria-label="Hero Section">
      {}
      <style dangerouslySetInnerHTML={{
      __html: `
          @keyframes ken-burns {
            0% { transform: scale(1); }
            100% { transform: scale(1.15); }
          }
          .animate-ken-burns {
            animation: ken-burns 20s ease-out infinite alternate;
          }
          .hero-clip-path {
            clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
          }
          @media (min-width: 1024px) {
            .hero-clip-path {
              clip-path: polygon(8% 0, 100% 0, 100% 100%, 0% 100%);
            }
          }
        `
    }} />

      <div className="grid min-h-[90vh] w-full grid-cols-1 lg:grid-cols-2">
        {}
        <div ref={ref} className="order-2 flex flex-col justify-center px-6 py-16 lg:order-1 lg:px-20 lg:py-24 xl:px-32">
          <div className="max-w-xl">
            <h1 className={`font-serif text-5xl font-medium leading-[1.1] tracking-tight text-primary sm:text-6xl lg:text-7xl transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              <span className="block">Helping families</span>
              <span className={`block transition-all duration-1000 delay-150 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>of the Hudson Valley</span>
              <span className={`block text-secondary transition-all duration-1000 delay-300 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>Find their&nbsp;<span className="text-red-600" data-ast-id="f:/src/pages/Home/sections/FindingYourOrangeCountyHome.tsx|sig:1u4lwb" data-ast-start="2673" data-ast-end="2865" contenteditable="false">home</span></span>
            </h1>

            <p className="mt-8 max-w-lg text-lg leading-relaxed text-muted-foreground transition-all duration-1000 delay-500 ease-out opacity-100 translate-y-0 !w-[495px] ![padding:0px_0px_3px_0px]">
              {description}
            </p>

            <div className={`mt-10 flex flex-wrap gap-4 transition-all duration-1000 delay-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              <Button asChild size="lg" className="bg-secondary text-secondary-foreground hover:bg-secondary/90 h-14 px-8 text-lg font-medium shadow-lg transition-transform hover:scale-105">
                <Link to="/CommunitiesPage">
                  Explore Communities
                  <ArrowRight className="ml-2 size-5" />
                </Link>
              </Button>
              
              <Button asChild variant="outline" size="lg" className="h-14 border-primary/20 bg-transparent px-8 text-lg font-medium text-primary hover:bg-primary/5">
                <Link to="/ReachOutPage">Contact Chris</Link>
              </Button>
            </div>
          </div>
        </div>

        {}
        <div className="relative order-1 h-[50vh] w-full overflow-hidden lg:order-2 lg:h-auto hero-clip-path">
          <div className="absolute inset-0 bg-primary/10 mix-blend-multiply z-10 pointer-events-none" />
          {isMounted && <div className="h-full w-full overflow-hidden">
              <img src="https://findahomewithchris.com/wp-content/uploads/2026/03/Headshot-1.jpg" alt="Sunrise over the Hudson Highlands in Orange County" className="h-full w-full object-cover object-center animate-ken-burns" />
            </div>}
        </div>
      </div>
    </section>;
}